module.exports = __webpack_public_path__ + "img/arrow_right_circle.46b20283.svg";